import { Expose, Transform } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";

export class SetCertificationsRegistrationDateBulkDto {
  @Expose()
  certificationIds: string[];

  @Transform(({ value }) => (value ? parseAppDate(value, false) : value))
  @Expose()
  registrationDate: Date;
}
